import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { EXCHANGE_SESSION_BY_EXCHANGE } from "../../Profile/constants/profileConstants";
import { getSessionTiming, isMarketOpen } from "../../Profile/utils/marketTimingsLogic";

// OPEN/CLOSED badge for the instrument's exchange; renders nothing when its session timing is unavailable
const MarketStatus = ({ exchange }) => {
  const theme = useTheme();
  const exchangeSessions = useSelector((state) => state.profile.exchangeSessions);
  const [, setTick] = useState(0);

  // Re-render every minute so the status flips while the window stays open
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(interval);
  }, []);

  const session = EXCHANGE_SESSION_BY_EXCHANGE[exchange];
  const timing = session ? getSessionTiming(session.sessionName, exchangeSessions) : null;
  if (!timing) return null;

  const isOpen = isMarketOpen(session.type, timing.open, timing.close);
  const color = isOpen ? "#22c55e" : theme.palette.error.main;

  return (
    // Spans + inline-flex so it can also flow inside the name text (mobile header).
    // Paper background keeps the badge readable on both the BUY and SELL header gradients.
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "middle",
        gap: 0.5,
        px: 0.75,
        py: 0.25,
        borderRadius: 1,
        bgcolor: theme.palette.background.paper,
        textShadow: "none",
      }}
    >
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: color }} />
      <Typography
        variant="caption"
        sx={{ fontSize: "0.65rem", fontWeight: 700, lineHeight: 1, letterSpacing: "0.2px", color }}
      >
        {isOpen ? "OPEN" : "CLOSED"}
      </Typography>
    </Box>
  );
};

export default MarketStatus;
